import { render, staticRenderFns } from "./VvStarNotation.vue?vue&type=template&id=4a149cd2&scoped=true&"
import script from "./VvStarNotation.vue?vue&type=script&lang=js&"
export * from "./VvStarNotation.vue?vue&type=script&lang=js&"
import style0 from "./VvStarNotation.vue?vue&type=style&index=0&id=4a149cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a149cd2",
  null
  
)

export default component.exports